/* eslint-disable class-methods-use-this */
import {
  cloneDeep,
  map,
  filter
} from 'lodash'
import downloadFile from './modelDownload'

const isJSONObj = (str) => {
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str)
      if (typeof obj === 'object' && obj && Object.keys(obj).length) {
        // typeof null 也为 object
        return true
      }
      return false
    } catch (e) {
      return false
    }
  }
  return false
}
const EnumObjectTypes = [
  'modelFile', // 模型类型
  'dynamicEffects',
]
class SceneLoader {
  sceneFileCount = 0
  player = null
  sceneData = null
  sceneRootNode = null
  sceneOptions = null
  sceneFileList = []
  constructor(player, sceneOptions, progressMsg, downloadMsg, downloadMaterialMsg, checkModelLoad, loadNodeCallback) {
    this.player = player
    this.sceneOptions = sceneOptions
    this.progressMsg = progressMsg
    this.downloadMsg = downloadMsg
    this.checkModelLoad = checkModelLoad
    this.downloadMaterialMsg = downloadMaterialMsg
    this.loadNodeCallback = loadNodeCallback
    console.log(sceneOptions, 'sceneOptions====================')

    this.loadScene()
  }
  apiConfig(data) {
    return {
      path: `${Wiz.GetApiClientInstance('file-management')?.basePath}/api/file-management/files/${data.code.modelFileId}/download`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ',
      },
    }
  }
  async resetSenece(sceneOptions) {
    const root = await this.player.Native.Node.getRoot()
    const node = await this.player.Native.Node.getProperty(root, [
      'children',
    ])
    if (node.children.length !== 0) {
      const nodes = node.children
        .map((o) => {
          return o.node
        })

      await this.player.Native.Node.destroy(nodes)
    }
    this.sceneOptions = sceneOptions
    this.loadScene()
  }
  // 加载模型
  async loadModel(file, name, parentNode) {
    const nodes = await this.player.Native.Node.loadFile(file)
    await this.player.Native.Node.setProperty(nodes, {
      name,
      parent: parentNode
    })
    await this.player.Native.Node.addToFactory(nodes)
    console.log(parentNode, 'parentNode==================', nodes)


    return nodes[0]
  }
  // 加载粒子节点
  async loadParticle(file, name, parentNode) {
    const particleNode = await this.player.Native.ParticleEffekseer.create(file)
    await this.player.Native.Node.setProperty(particleNode, {
      name,
      parent: parentNode
    })
    return particleNode
  }
  async loadSceneFromJson(
    obj,
    parentNode,
    sceneOptions = {
      isEnableGis: false,
      latitude: 0,
      longitude: 0,
    },
    nodes = [],
    loadCallback = () => {}
  ) {
    let node = null
    // 根据节点类型，序列化某些特有类型的节点数据
    console.log(obj.code.type, 'obj.code.type--------', parentNode)

    switch (obj.code.type) {
      case 'modelFile':
        node = await this.loadModel(obj.code.filePath, obj.code.id, parentNode)
        break
      case 'dynamicEffects':
        node = await this.loadParticle(obj.code.filePath, obj.name, parentNode)
        break
      case 'engineering':
        node = await this.loadModel(obj.code.filePath, obj.code.id, parentNode)
        break
      default:
        // 层级节点，直接根据名称创建节点
        node = await this.player.Native.Node.create()
        await this.player.Native.Node.setProperty(node, {
          name: obj.name,
          parent: parentNode
        })
        break
    }
    nodes.push({
      type: obj.code.type,
      nodePtr: node
    })
    loadCallback(nodes)
    // 节点创建失败，返回nullptr
    if (node !== null && node !== 0) {
      await this.player.Native.Node.setProperty(node, {
        name: obj.name,
        code: JSON.stringify(obj.code),
        id: obj.guid,
        localTrans: obj.localPosition,
        localRot: obj.localRotation,
        localScale: obj.localScaling,
      })
      // 递归子，继续创建
      if (obj.children && obj.children.length) {
        for (let i = 0; i < obj.children.length; ++i) {
          console.log(node, 'as parentNode=============================')

          await this.loadSceneFromJson(obj.children[i], node, sceneOptions, nodes, loadCallback)
        }
      }
    }
    return nodes
  }
  // 加载进度
  LoadNodeCallback() {
    const that = this
    const fun = (data) => {
      const scenceModelList = _.filter(that.sceneFileList, (item) => {
        return (
          item.code && (item.code?.type === 'modelFile' || item.code?.type === 'dynamicEffects')
        )
      })
      const loadNodes = _.filter(data, (item) => {
        return item.type === 'modelFile' || item.type === 'dynamicEffects'
      })
      if (loadNodes.length <= scenceModelList.length) {
        const loadPercentage = _.round((loadNodes.length / scenceModelList.length) * 100, 2)
        that.loadNodeCallback(loadPercentage)
      }
    }
    return fun
  }

  // 移动相机到经纬度
  async moveToLLH(long, lat) {
    if (long && lat) {
      const elevation = (
        await this.player.Native.GisPlatform.queryDEM([
          [long, lat, 0]
        ])
      )[0]
      this.player.Native.Camera.addMoveToLLH([long, lat, 20000], 0)
      this.player.Native.Camera.addMoveToLLH([long, lat, elevation + 800], 3)
    }
  }
  // 加载模型
  async addModel() {
    // 加载模型前，检测模型是否全部下载完成
    if (this.sceneFileCount < this.sceneFileList.length) {
      this.checkTextureFile(this.sceneFileList[this.sceneFileCount])
    } else {
      this.checkModelLoad(true)
      // 模型加载完后开始加载
      const nodeList = await this.loadSceneFromJson(
        this.sceneData,
        this.sceneRootNode,
        this.sceneOptions,
        [],
        this.LoadNodeCallback()
      )
      this.sceneFileCount = 0
      this.checkModelLoad(false)
      if (this.sceneData.cameraParams && isJSONObj(this.sceneData.cameraParams)) {
        const {
          eye,
          target,
          up
        } = JSON.parse(this.sceneData.cameraParams)
        await this.player.Native.Camera.moveTo(eye, target, up, 2)
      } else if (this.sceneOptions.isEnableGis) {
        await this.moveToLLH(this.sceneOptions.longitude, this.sceneOptions.latitude)
      } else {
        const currentNodes = _.map(_.filter(nodeList, ['type', 'modelFile']), 'nodePtr')
        await this.player.Native.Camera.moveToNode(currentNodes, 2)
      }
    }
  }

  // 检查文件是否存在
  async checkTextureFile(data) {
    if (data && data.code && data.code.modelFileId) {
      if (data.code.materialFileId && data.code.materialFileId !== 'undefined') {
        const url = `data://../apps/${data.code.filePath.split('/')[4]}/models/${data.code.modelFileId}/${data.code.materialFileId}.zip`
        const fileInfo = {
          id: data.code.materialFileId,
          url,
          fileType: 'zip',
        }
        const res = await downloadFile(
          this.player,
          fileInfo,
          this.apiConfig(data),
          this.progressMsg,
          this.DownloadMaterialMsg(data)
        )
        if (res.type === 0 && res.success) {
          this.checkModelFile(data)
        } else {
          this.downloadMaterialMsg(true)
        }
      } else {
        this.checkModelFile(data)
      }
    }
  }
  // 检查模型是否存在
  async checkModelFile(data) {
    const fileType = _.last(data.code.filePath.split('.')) || 'pr'
    const url = data.code.filePath
    const fileInfo = {
      id: data.code.modelFileId,
      url,
      fileType,
    }
    const res = await downloadFile(
      this.player,
      fileInfo,
      this.apiConfig(data),
      this.progressMsg,
      this.DownloadMsg
    )
    if (res.type === 0 && res.success) {
      // 有模型就加载模型
      this.sceneFileCount += 1
      this.addModel()
    } else {
      this.downloadMsg(true)
    }
  }
  // 监听下载模型是否成功
  DownloadMsg(file, err) {
    this.downloadMsg(file, err)
    // 模型下载完成
    this.sceneFileCount += 1
    this.addModel()
  }
  // 监听下载模型是否成功
  DownloadMaterialMsg(data) {
    const fun = async (file, err) => {
      this.downloadMaterialMsg(false, file, err)
      setTimeout(() => {
        this.checkModelFile(data)
      }, 500)
    }
    return fun
  }
  // 加载场景---入口
  async loadScene() {
    this.sceneRootNode = await this.player.Native.Node.getRoot()
    console.log(this.sceneRootNode, 'sceneRootNodesceneRootNodesceneRootNodesceneRootNode')

    if (this.sceneOptions.jsonData && isJSONObj(this.sceneOptions.jsonData)) {
      this.sceneData = JSON.parse(this.sceneOptions.jsonData)
      this.sceneFileList = await this.getNodesByNodeType(this.sceneData, [])
      if (!_.isEmpty(this.sceneFileList)) {
        this.checkTextureFile(this.sceneFileList[0])
      } else {
        await this.loadSceneFromJson(
          this.sceneData,
          this.sceneRootNode,
          this.sceneOptions,
          [],
          this.LoadNodeCallback()
        )
        if (this.sceneData.cameraParams && isJSONObj(this.sceneData.cameraParams)) {
          const {
            eye,
            target,
            up
          } = JSON.parse(this.sceneData.cameraParams)
          await this.player.Native.Camera.moveTo(eye, target, up, 2)
        } else if (this.sceneOptions.isEnableGis) {
          await this.moveToLLH(this.sceneOptions.longitude, this.sceneOptions.latitude)
        }
      }
    } else {
      const nodePtr = await this.player.Native.Node.create()
      await this.player.Native.Node.setProperty(nodePtr, {
        name: this.sceneOptions.name,
        parent: this.sceneRootNode,
        code: JSON.stringify({
          type: 'Root',
          fileType: '',
          filePath: '',
          scene: this.sceneOptions.id,
          isEnableGis: this.sceneOptions.isEnableGis,
        }),
      })
      this.checkModelLoad(false)
      if (
        this.sceneOptions.isEnableGis &&
        this.sceneOptions.longitude &&
        this.sceneOptions.latitude
      ) {
        const elevation = (
          await this.player.Native.GisPlatform.queryDEM([
            [this.sceneOptions.longitude, this.sceneOptions.latitude, 0],
          ])
        )[0]
        const mat = await this.player.Native?.GisPlatform.makeGisTransform([
          this.sceneOptions.longitude,
          this.sceneOptions.latitude,
          elevation,
        ])
        await this.player.Native?.Node.setProperty(nodePtr, {
          wholeMatrix: mat
        })
        this.moveToLLH(this.sceneOptions.longitude, this.sceneOptions.latitude)
      }
    }
  }
  // 通过指定节点去查下面的子节点 nodeType 指定节点的类型，obj 需要筛选的对象数据源，arr 接收筛选后的数据集合
  async getNodesByNodeType(obj, arr = []) {
    const currentNodeType = obj?.code?.type
    if (EnumObjectTypes.includes(currentNodeType)) {
      const nowObj = cloneDeep(obj)
      delete nowObj.children
      arr.push(nowObj)
    }
    // 递归子，继续创建
    if (obj.children && obj.children.length) {
      for (let i = 0; i < obj.children.length; i += 1) {
        await this.getNodesByNodeType(obj.children[i], arr)
      }
    }
    return arr
  }
}

export default SceneLoader
